import React from 'react';

type Props = {
    serviceName: string;
    serviceDescription: any;
};

const SubSupplyServices: React.FC<Props> = ({ serviceName, serviceDescription }) => {
    return (
        <div
            className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="300"
        >
            <div className="card-body">
                <h3 className="card-title fs-lg fw-700 mb-5 text-textcolor">{serviceName}</h3>
                <p className="card-text fs-md fw-400 text-secondary mb-0">{serviceDescription}</p>
            </div>
        </div>
    );
};

export default SubSupplyServices;
